import React from 'react';
import ArticleItem from './ArticleItem';
import './Articles.css';


function Articles() {
  return (

    <section id="articles" class="articles" style={{scrollSnapAlign: 'start'}}>
      <h1 className='title'>./Articles</h1>
        <div class="main">
          <ul class="cards">
            <ArticleItem
              image_src="/images/article_backgrounds/gan.jpg"
              title="Generative Adversarial Networks: A Rival Makes You Stronger"
              link="https://medium.com/analytics-vidhya/generative-adversarial-networks-a-rival-makes-you-stronger-d0b2aa87e06c"
              tags="ML"
            />
            <ArticleItem
              image_src="/images/article_backgrounds/abstractive_text.jpg"
              title="Abstractive Text Summarization"
              link="https://medium.com/@soum1071/abstractive-text-summarization-33edf197a54c"
              tags="Python/NLP/DL"
            />
            <ArticleItem
              image_src="/images/article_backgrounds/tensorflow.jpg"
              title="Tensorflow: Hello World"
              link="https://medium.com/@soum1071/tensorflow-hello-world-9320004cfa9f"
              tags="Python/Tensorflow"
            />
          </ul>

        </div>


    </section >
  )
}

export default Articles